<template>
  <div class="pdf-preview-wrap" style="position: relative;">
    <LoadingSpinner v-if="loading" border :display-text="$gettext('Generating preview')" />
    <iframe v-if="!loading && invoicePDF" class="pdf-preview" :src="invoicePDF"></iframe>
  </div>
</template>
<script>
import axios from 'axios'

import { mapGetters, mapMutations } from 'vuex'

import InvoiceLayoutService from '@/store/services/invoice.layout.service.js'
import LoadingSpinner from '@/components/dashboard/ui/LoadingSpinner'

export default {
  name: "InvoicePDFPreview",
  components: {
    LoadingSpinner
  },
  props: {
    invoiceId: {
      type: [Number, String],
      default: null
    },
  },
  data () {
    return {
      loading: true,
      controllerSignal: null,
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
      invoicePDF: "invoices/getInvoicePDF",
    }),
    isRecurrent () {
      return this.invoice.status === 'recurrent' // pdf does not exist yet
    }
  },
  created () {
    this.setupData()
  },
  beforeDestroy () {
    this.cancelPDFRequest()
  },
  methods: {
    ...mapMutations({ 
      setInvoicePDF: 'invoices/SET_INVOICE_PDF',
    }),
    setupData () {
      this.getInvoicePDF()
    },
    cancelPDFRequest () {
      if (this.controllerSignal) {
        this.controllerSignal.abort()
      }
    },
    getInvoicePDF () {
      if (!this.invoicePDF) {
        if (this.invoiceId) {
          if (this.isRecurrent) {
            InvoiceLayoutService.previewPdf(this.getInvoicePreviewData()).then((response) => {
              this.setInvoicePDF(response.replace('application/octet-stream', 'application/pdf'))
              this.loading = false
            })
          } else {
            this.controllerSignal = new AbortController();
            InvoiceLayoutService.getInvoicePDFb64(this.invoiceId, this.controllerSignal).then((response) => {
              this.setInvoicePDF(response.replace('application/octet-stream', 'application/pdf'))
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
          
        }
      } else {
        this.loading = false
      }
    },
    getInvoicePreviewData () {
      // get totals (fn copied from InvoiceLines.vatTotals())
      const vat_totals = {}
      this.invoice.invoice_lines.forEach(invoice_line => {
        if((invoice_line.amount > 0 || invoice_line.amount < 0) && !invoice_line.vat_exempt) {
          if (!vat_totals[invoice_line.tax_rate]) {
            vat_totals[invoice_line.tax_rate] = 0
          }
          if (this.invoice.line_amount_is_gross) {
            vat_totals[invoice_line.tax_rate] += Math.round(invoice_line.multiplier * invoice_line.amount * 100) / 100 - Math.round((invoice_line.multiplier * invoice_line.amount / ( 1 + invoice_line.tax_rate / 100)) * 100) / 100
          } else {
            vat_totals[invoice_line.tax_rate] += Math.round(invoice_line.multiplier * invoice_line.amount * (invoice_line.tax_rate / 100) * 100) / 100
          }
        }
      })

      const previewData = {
        invoice: this.invoice, 
        totals: {
          vat_totals: Object.entries(vat_totals).map(([key, value]) => [parseInt(key), value]),
          subtotal: this.invoice.subtotal_amount,
          total: this.invoice.total_amount
        },
        layout: this.invoice.layout, 
        recipient: this.invoice.recipient_customer
      }
      return previewData
    }
  }
}
</script>
<style scoped lang="scss">

.pdf-preview-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  .pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
  }
}

</style>